import RefreshIcon from '@mui/icons-material/Refresh';
import { Box, Card, CardContent, IconButton, Typography } from '@mui/material';
import { useState } from 'react';
import {
  List,
  useListContext,
  useRecordContext,
  useTranslate,
} from 'react-admin';
import ListPagination from '../../components/ListPagination';
import { StandaloneDateRangeInput } from '../../components/StandaloneDateTimeInput';
import { ChangeLogDatagrid } from './ChangeLogDatagrid';

const ListActions = () => {
  const { refetch, isFetching } = useListContext();
  const translate = useTranslate();
  return (
    <IconButton
      onClick={() => refetch()}
      disabled={isFetching}
      aria-label={translate('Atualizar')}
      size="small"
      sx={{ mr: 1 }}
    >
      <RefreshIcon />
    </IconButton>
  );
};

interface EntityChangeLogTabProps {
  entityType: 'chain' | 'place';
}

export const EntityChangeLogTab = ({ entityType }: EntityChangeLogTabProps) => {
  const record = useRecordContext();
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);

  if (!record) return null;

  const filter: any = { entityType, entityId: record.id };
  if (startDate) filter.from = startDate;
  if (endDate) filter.to = endDate;

  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
          Histórico de Alterações
        </Typography>

        <Box sx={{ mb: 2 }}>
          <StandaloneDateRangeInput
            fromValue={startDate}
            toValue={endDate}
            onFromChange={setStartDate}
            onToChange={setEndDate}
            fromLabel="Data Inicial"
            toLabel="Data Final"
          />
        </Box>

        <List
          resource="change-log"
          filter={filter}
          pagination={<ListPagination />}
          actions={<ListActions />}
          disableSyncWithLocation
          sort={{ field: 'changedAt', order: 'DESC' }}
        >
          <ChangeLogDatagrid />
        </List>
      </CardContent>
    </Card>
  );
};
